import { absoluteLoaderTheme } from 'components/AbsoluteLoader/theme';
import { appLoaderTheme } from 'components/AppLoader/theme';
import { infoBlockTheme } from 'components/Blocks/InfoBlock/theme';
import { breadCrumbTheme } from 'components/BreadCrumb/theme';
import { BurgerTheme } from 'components/BurgerMenu/theme';
import { buttonTheme } from 'components/Button/theme';
import { controlledPopover } from 'components/ControlledPopover/theme';
import { autocompleteSelectTheme } from 'components/Controls/AutocompleteSelect/theme';
import { checkboxTheme } from 'components/Controls/Checkbox/theme';
import { countryPhoneTheme } from 'components/Controls/CountryPhone/theme';
import { datePickerListTheme } from 'components/Controls/DatePickerList/theme';
import { inputTheme } from 'components/Controls/Input/theme';
import { radioSelectTheme } from 'components/Controls/RadioSelect/theme';
import { richEditorTheme } from 'components/Controls/RichEditor/theme';
import { switchTheme } from 'components/Controls/Switch/theme';
import { switchInputTheme } from 'components/Controls/SwitchInput/theme';
import { textAreaTheme } from 'components/Controls/TextArea/theme';
import { datepickerTheme } from 'components/Datepicker/theme';
import { detailTheme } from 'components/Detail/theme';
import { dividerTheme } from 'components/Divider/theme';
import { dropZoneTheme } from 'components/DropZone/theme';
import { dropFileZoneTheme } from 'components/Form/DropFileZone/theme';
import { errorMessageTheme } from 'components/Form/ErrorMessage/theme';
import { fieldWrapperTheme } from 'components/Form/FieldWrapper/theme';
import { formNavigationTheme } from 'components/Form/FormNavigation/theme';
import { formHeaderTheme } from 'components/Form/Header/theme';
import { sectionErrorTheme } from 'components/Form/SectionError/theme';
import { formTheme } from 'components/Form/theme';
import { filtersTheme } from 'components/Grids/DataGrid/Filters/Sidebar/theme';
import { dataGridTheme } from 'components/Grids/DataGrid/theme';
import { timerBoxTheme } from 'components/HeaderClocks/theme';
import { highlightedTextTheme } from 'components/HighlightedText/theme';
import { linkTheme } from 'components/Link/theme';
import { loaderTheme } from 'components/Loader/styled';
import { logoTheme } from 'components/Logo/theme';
import { markdownContentTheme } from 'components/MarkdownContent/theme';
import { modalContainerTheme } from 'components/ModalContainer/theme';
import { noItemsFoundTheme } from 'components/NoItemsFound/theme';
import { notificationTheme } from 'components/Notification/theme';
import { colorItemTheme } from 'components/Pickers/ColorItem/theme';
import { colorPickerInputTheme } from 'components/Pickers/ColorPickerInput/theme';
import { colorPickerTheme } from 'components/Pickers/ColorPickerPopover/ColorPicker/theme';
import { variableColorPickerTheme } from 'components/Pickers/VariableColorPickerPopover/VariableColorPicker/theme';
import { popoverTheme } from 'components/Popover/theme';
import { presetsListTheme } from 'components/PresetsList/theme';
import { previewAppTheme } from 'components/PreviewApp/theme';
import { profilePopoverTheme } from 'components/ProfilePopover/theme';
import { qrCodeTheme } from 'components/QRCode/theme';
import { radioCardGroupTheme } from 'components/RadioCardGroup/theme';
import { randomImagePreviewTheme } from 'components/RandomImgPreview/theme';
import { groupEditListItemTheme } from 'components/RightSidebar/ListItem/theme';
import { rightSidebar } from 'components/RightSidebar/theme';
import { scrollbarTheme } from 'components/Scrollbar/theme';
import { selectModalEnterTheme } from 'components/SelectModalEnter/theme';
import { switchCustomTheme } from 'components/SwitchCustom/theme';
import { tabsTheme, tabTheme } from 'components/Tabs/theme';
import { statusTheme } from 'components/Tags/Status/theme';
import { tagTheme } from 'components/Tags/Tag/theme';
import { tooltipTheme } from 'components/Tooltip/theme';
import { transferEnterTheme } from 'components/Transfers/TransferEnter/theme';
import { transferListTheme } from 'components/Transfers/TransferList/theme';
import { transferPageTheme } from 'components/Transfers/TransferPage/theme';
import { transferTreeTheme } from 'components/Transfers/TransferTree/theme';
import { transferTreeHeaderTheme } from 'components/Transfers/TransferTree/TransferListHeader/theme';
import { typographyTheme } from 'components/Typography/theme';
import { viewModeSwitcherTheme } from 'components/ViewStyleSwitcher/theme';
import { confirmActionModalTheme } from 'modals/ConfirmActionModal/theme';
import { settingsTheme } from 'routes/pages/AuthorizedStack/Settings/PortalSettings/theme';
import { wrongPageTheme } from 'routes/pages/UnauthorizedStack/SomethingWrongPages/WrongPageLayout/theme';

import { blockDetailTheme } from '../components/Blocks/BlockDetail/theme';
import { periodInputsTheme } from '../components/Controls/PeriodInputs/theme';
import { formikFiltersSectionTheme } from '../components/Form/FormikFiltersSection/theme';
import { popoverColorPickerTheme } from '../components/Form/FormikPopoverColorPicker/theme';
import { multiPreselectedFieldTheme } from '../components/Form/MultiPreselectedField/theme';
import { preselectedFieldTheme } from '../components/Form/PreselectedField/theme';
import { sidebarFieldsTheme } from '../components/SidebarField/theme';
import { verifyOtpModalTheme } from '../modals/VerifyOtp/theme';

export enum COMPONENTS_NAMES {
  ABSOLUTE_LOADER = 'absoluteLoader',
  APP_LOADER = 'appLoader',
  AUTOCOMPLETE_SELECT = 'autocompleteSelect',
  BLOCK_DETAIL = 'blockDetail',
  BREAD_CRUMB = 'breadCrumb',
  BURGER = 'burger',
  BUTTON = 'button',
  CHECKBOX = 'checkbox',
  COLOR_ITEM = 'colorItem',
  COLOR_PICKER = 'colorPicker',
  COLOR_PICKER_INPUT = 'colorPickerInput',
  CONFIRM_ACTION_MODAL = 'confirmActionModal',
  CONTROLLED_POPOVER = 'controlledPopover',
  COUNTRY_PHONE = 'countryPhone',
  DATA_GRID = 'dataGrid',
  DATEPICKER = 'datepicker',
  DATEPICKER_LIST = 'datepickerList',
  DETAIL = 'detail',
  DIVIDER = 'divider',
  DROP_FILE_ZONE = 'dropFileZone',
  DROP_ZONE = 'dropZone',
  ERROR_MESSAGE = 'errorMessage',
  FIELD_WRAPPER = 'fieldWrapper',
  FILTERS = 'filters',
  FORM = 'form',
  FORM_HEADER = 'formHeader',
  FORMIK_FILTERS_SECTION = 'formikFiltersSection',
  FROM_NAVIGATION = 'fromNavigation',
  GROUP_EDIT_LIST_ITEM = 'groupEditListItem',
  HIGHLIGHTED_TEXT = 'highlightedText',
  INFO_BLOCK = 'infoBlock',
  INPUT = 'input',
  LINK = 'link',
  LOADER = 'loader',
  LOGO = 'logo',
  MARKDOWN_CONTENT = 'markdownContent',
  MODAL_CONTAINER = 'modalContainer',
  MULTI_PRESETED_FIELD = 'multiPresetedField',
  NO_ITEMS_FOUND = 'noItemsFound',
  NOTIFICATION = 'notification',
  PERIOD_INPUTS = 'periodInputs',
  POPOVER = 'popover',
  POPOVER_COLOR_PICKER = 'popoverColorPicker',
  PRESETED_FIELD = 'presetedField',
  PRESETS_LIST = 'presetsList',
  PREVIEW_APP = 'previewApp',
  PROFILE_POPOVER = 'profilePopover',
  QR_CODE = 'qrCode',
  RADIO_CARD_GROUP = 'radioCardGroup',
  RADIO_SELECT = 'radioSelect',
  RANDOM_IMAGE_PREVIEW = 'randomImagePreview',
  RICH_EDITOR = 'richEditor',
  RIGHT_SIDEBAR = 'rightSidebar',
  SCROLLBAR = 'scrollbar',
  SECTION_ERROR = 'sectionError',
  SELECT_MODAL_ENTER = 'selectModalEnter',
  SIDEBAR_FIELDS = 'sidebarFields',
  STATUS = 'status',
  SURFACE_PREVIEW = 'surfacePreview',
  SWITCH = 'switch',
  SWITCH_CUSTOM = 'switchCustom',
  SWITCH_INPUT = 'switchInput',
  TAB = 'tab',
  TABS = 'tabs',
  TAG = 'tag',
  TEXT_AREA = 'textArea',
  TIMER_BOX = 'timerBox',
  TOOLTIP = 'tooltip',
  TRANSFER_ENTER = 'transferEnter',
  TRANSFER_LIST = 'transferList',
  TRANSFER_PAGE = 'transferPage',
  TRANSFER_TREE = 'transferTree',
  TRANSFER_TREE_HEADER = 'transferTreeHeader',
  TYPOGRAPHY = 'typography',
  VARIABLE_PICKER = 'variableColorPicker',
  VERIFY_OTP_MODAL = 'verifyOtpModal',
  VIEW_MODE_SWITCHER = 'viewModeSwitcher',
  WRONG_PAGE = 'wrongPage',
}

export const COMPONENTS_MAPPING = Object.fromEntries(
  Object.entries(COMPONENTS_NAMES).map(([_key, value]) => [value, value]),
);

export const COMPONENTS_DEFAULT_THEMES = {
  [COMPONENTS_NAMES.ABSOLUTE_LOADER]: absoluteLoaderTheme,
  [COMPONENTS_NAMES.APP_LOADER]: appLoaderTheme,
  [COMPONENTS_NAMES.AUTOCOMPLETE_SELECT]: autocompleteSelectTheme,
  [COMPONENTS_NAMES.BLOCK_DETAIL]: blockDetailTheme,
  [COMPONENTS_NAMES.BREAD_CRUMB]: breadCrumbTheme,
  [COMPONENTS_NAMES.BURGER]: BurgerTheme,
  [COMPONENTS_NAMES.BUTTON]: buttonTheme,
  [COMPONENTS_NAMES.CHECKBOX]: checkboxTheme,
  [COMPONENTS_NAMES.COLOR_ITEM]: colorItemTheme,
  [COMPONENTS_NAMES.COLOR_PICKER]: colorPickerTheme,
  [COMPONENTS_NAMES.COLOR_PICKER_INPUT]: colorPickerInputTheme,
  [COMPONENTS_NAMES.CONFIRM_ACTION_MODAL]: confirmActionModalTheme,
  [COMPONENTS_NAMES.CONTROLLED_POPOVER]: controlledPopover,
  [COMPONENTS_NAMES.COUNTRY_PHONE]: countryPhoneTheme,
  [COMPONENTS_NAMES.DATA_GRID]: dataGridTheme,
  [COMPONENTS_NAMES.DATEPICKER]: datepickerTheme,
  [COMPONENTS_NAMES.DATEPICKER_LIST]: datePickerListTheme,
  [COMPONENTS_NAMES.DETAIL]: detailTheme,
  [COMPONENTS_NAMES.DIVIDER]: dividerTheme,
  [COMPONENTS_NAMES.DROP_FILE_ZONE]: dropFileZoneTheme,
  [COMPONENTS_NAMES.DROP_ZONE]: dropZoneTheme,
  [COMPONENTS_NAMES.ERROR_MESSAGE]: errorMessageTheme,
  [COMPONENTS_NAMES.FIELD_WRAPPER]: fieldWrapperTheme,
  [COMPONENTS_NAMES.FILTERS]: filtersTheme,
  [COMPONENTS_NAMES.FORM]: formTheme,
  [COMPONENTS_NAMES.FORM_HEADER]: formHeaderTheme,
  [COMPONENTS_NAMES.FORMIK_FILTERS_SECTION]: formikFiltersSectionTheme,
  [COMPONENTS_NAMES.FROM_NAVIGATION]: formNavigationTheme,
  [COMPONENTS_NAMES.GROUP_EDIT_LIST_ITEM]: groupEditListItemTheme,
  [COMPONENTS_NAMES.HIGHLIGHTED_TEXT]: highlightedTextTheme,
  [COMPONENTS_NAMES.INFO_BLOCK]: infoBlockTheme,
  [COMPONENTS_NAMES.INPUT]: inputTheme,
  [COMPONENTS_NAMES.LINK]: linkTheme,
  [COMPONENTS_NAMES.LOADER]: loaderTheme,
  [COMPONENTS_NAMES.LOGO]: logoTheme,
  [COMPONENTS_NAMES.MARKDOWN_CONTENT]: markdownContentTheme,
  [COMPONENTS_NAMES.MODAL_CONTAINER]: modalContainerTheme,
  [COMPONENTS_NAMES.MULTI_PRESETED_FIELD]: multiPreselectedFieldTheme,
  [COMPONENTS_NAMES.NO_ITEMS_FOUND]: noItemsFoundTheme,
  [COMPONENTS_NAMES.NOTIFICATION]: notificationTheme,
  [COMPONENTS_NAMES.PERIOD_INPUTS]: periodInputsTheme,
  [COMPONENTS_NAMES.POPOVER]: popoverTheme,
  [COMPONENTS_NAMES.POPOVER_COLOR_PICKER]: popoverColorPickerTheme,
  [COMPONENTS_NAMES.PRESETED_FIELD]: preselectedFieldTheme,
  [COMPONENTS_NAMES.PRESETS_LIST]: presetsListTheme,
  [COMPONENTS_NAMES.PREVIEW_APP]: previewAppTheme,
  [COMPONENTS_NAMES.PROFILE_POPOVER]: profilePopoverTheme,
  [COMPONENTS_NAMES.QR_CODE]: qrCodeTheme,
  [COMPONENTS_NAMES.RADIO_CARD_GROUP]: radioCardGroupTheme,
  [COMPONENTS_NAMES.RADIO_SELECT]: radioSelectTheme,
  [COMPONENTS_NAMES.RANDOM_IMAGE_PREVIEW]: randomImagePreviewTheme,
  [COMPONENTS_NAMES.RICH_EDITOR]: richEditorTheme,
  [COMPONENTS_NAMES.RIGHT_SIDEBAR]: rightSidebar,
  [COMPONENTS_NAMES.SCROLLBAR]: scrollbarTheme,
  [COMPONENTS_NAMES.SECTION_ERROR]: sectionErrorTheme,
  [COMPONENTS_NAMES.SELECT_MODAL_ENTER]: selectModalEnterTheme,
  [COMPONENTS_NAMES.SIDEBAR_FIELDS]: sidebarFieldsTheme,
  [COMPONENTS_NAMES.STATUS]: statusTheme,
  [COMPONENTS_NAMES.SURFACE_PREVIEW]: settingsTheme.examples.surfacePreview,
  [COMPONENTS_NAMES.SWITCH]: switchTheme,
  [COMPONENTS_NAMES.SWITCH_CUSTOM]: switchCustomTheme,
  [COMPONENTS_NAMES.SWITCH_INPUT]: switchInputTheme,
  [COMPONENTS_NAMES.TAB]: tabTheme,
  [COMPONENTS_NAMES.TABS]: tabsTheme,
  [COMPONENTS_NAMES.TAG]: tagTheme,
  [COMPONENTS_NAMES.TEXT_AREA]: textAreaTheme,
  [COMPONENTS_NAMES.TIMER_BOX]: timerBoxTheme,
  [COMPONENTS_NAMES.TOOLTIP]: tooltipTheme,
  [COMPONENTS_NAMES.TRANSFER_ENTER]: transferEnterTheme,
  [COMPONENTS_NAMES.TRANSFER_LIST]: transferListTheme,
  [COMPONENTS_NAMES.TRANSFER_PAGE]: transferPageTheme,
  [COMPONENTS_NAMES.TRANSFER_TREE]: transferTreeTheme,
  [COMPONENTS_NAMES.TRANSFER_TREE_HEADER]: transferTreeHeaderTheme,
  [COMPONENTS_NAMES.TYPOGRAPHY]: typographyTheme,
  [COMPONENTS_NAMES.VARIABLE_PICKER]: variableColorPickerTheme,
  [COMPONENTS_NAMES.VERIFY_OTP_MODAL]: verifyOtpModalTheme,
  [COMPONENTS_NAMES.VIEW_MODE_SWITCHER]: viewModeSwitcherTheme,
  [COMPONENTS_NAMES.WRONG_PAGE]: wrongPageTheme,
};
